export const CART_ITEMS_TYPES = {
  FURNITURE : "furniture",
  SAMPLE : "sample",
  DESIGN : "design",
};
